var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isValid)?_c('section',{attrs:{"id":_vm.container}},[_c('script',{attrs:{"type":"application/javascript"}},[_vm._v("_tla('"+_vm._s(_vm.action)+"', '"+_vm._s(_vm.zoneId)+"', '"+_vm._s(_vm.container)+"');")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }